import React from "react";
import "./newsCardSkeleton.css";

const NewsCardSkeleton = () => {
  return (
    <div className="col-lg-4 col-md-6 d-flex">
      <div className="news-card-md news-card-skeleton w-100">
        {/* Thumb area skeleton */}
        <div className="news-thumb-skeleton skeleton-shimmer">
          {/* Date badge skeleton */}
          <div className="skeleton-date-badge"></div>
          {/* Source label skeleton */}
          <div className="skeleton-source-label"></div>
          {/* Title block skeleton */}
          <div className="skeleton-title-block"></div>
        </div>

        {/* Content area skeleton */}
        <div className="news-content">
          {/* Categories skeleton */}
          <div className="skeleton-categories">
            <span className="skeleton-category skeleton-shimmer"></span>
            <span className="skeleton-category skeleton-shimmer"></span>
          </div>
          
          {/* Description skeleton */}
          <div className="skeleton-desc-lines">
            <div className="skeleton-line skeleton-shimmer"></div>
            <div className="skeleton-line skeleton-shimmer"></div>
            <div className="skeleton-line skeleton-line-short skeleton-shimmer"></div>
          </div>
          
          {/* Footer skeleton */}
          <div className="skeleton-footer">
            <div className="skeleton-read-more skeleton-shimmer"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCardSkeleton;
